module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "add-ios.5dfc6c06.png";